import Vue from 'vue'

import LoadingOverlay from './LoadingOverlay';

Vue.component('module-loading-overlay', LoadingOverlay)
